import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Feedback from '../../../../../../components/mui/Feedback';
import FormComponent from './FormComponent';
import DeleteComponent from './DeleteComponent';
import { setFormData, setFormType, setIsOpenModal, setIsLoadingShow, setIsLoadingForm } from '../redux/actions/propertyReserveAction';
import usePermission from '../../../../../../hooks/usePermission';
import { initialValuesPropertyReserve as initialValues } from '../../../../../../helpers/variablesInitialValues';

const ModalComponent = () => {
	const dispatch = useDispatch();
	const isOpenModal = useSelector( ({ propertyReserve }) => propertyReserve.isOpenModal);
	const formType = useSelector( ({ propertyReserve }) => propertyReserve.formType);
	const permissionStore = usePermission('propertyReserves.store');
	const permissionShow = usePermission('propertyReserves.show');
	const permissionDelete = usePermission('propertyReserves.delete');
	
	/**
	 *
	 * @description Execute reset formData, loading show, loading form, close modal state
	 * @return dispatch
	 *
	 */
	const handleCloseModal = async () => {
		await dispatch( setFormData(initialValues) );
		await dispatch( setFormType('') );
		await dispatch( setIsLoadingShow(false) );
		await dispatch( setIsLoadingForm(false) );
		await dispatch( setIsOpenModal(false) );
	};
	
	return (
		<Feedback.Modal
			maxWidth="sm"
			isOpen={isOpenModal}
			isClose={handleCloseModal}
			title={formType === 'delete' ? `Eliminación de la reserva` : 'Captación de reservas'}
		>
			{(formType === 'store' || formType === 'show') && (
				(formType === 'store' ? permissionStore : permissionShow) && (
					<FormComponent />
				)
			)}
			{formType === 'delete' && (
				permissionDelete && (
					<DeleteComponent />
				)
			)}
		</Feedback.Modal>
	);
};

export default ModalComponent;
